import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { REPORT_TYPES } from "../../../../constants/app-constant";

const {
  JournalistNOARanking,
  JournalistAnalysisPrint,
  JournalistNOATrend,
  SOV_NOA_TREND,
  JournalistTonalityNOARanking,
  PublicationNOATrend,
  SOVTonality,
  SOVRanking,
  TonalityNAORanking,
  PublicationNOARanking,
  PublicationTonalityNOARanking,
  CityWiseNOARanking,
  CityWiseNOATrend,
  CityWiseTonality,
  StateWiseTonality,
  CityWiseCCMTonality,
  CityWiseMAVTonality,
  CityWiseCCMRanking,
  CityWiseMAVRanking,
  EditionWiseNOATrend,
  MediaWiseNOARanking,
  ThematicAnalysisTag,
  ThematicAnalysisEntity,
} = REPORT_TYPES;

const formatData = ({ datasets }) => {
  if (!datasets) return;
  return datasets
    .map((elm) => ({
      name: elm.label,
      data:
        elm.data &&
        elm.data
          .map((el) => parseInt(el))
          .sort((a, b) => parseFloat(b) - parseFloat(a)),
      color: elm.backgroundColor,
    }))
    .sort((a, b) => parseFloat(b.data) - parseFloat(a.data));
};
export const HorizontalBarChartHC = function ({
  graphApiResponse = { hcData: [{}] },
  onEntityClick,
  reportType,
  entityList,
  dataByReportType,
  editionList,
  isEmbededWidget,
  chartTitle,
  setGraphRef,
  setGraphRefList,
  mediaType,
}) {
  const ref = useRef();
  const [lineChartData, setLineChartData] = useState({});

  useEffect(() => {
    setGraphRef(ref);
  }, []);

  useEffect(() => {
    redrawChart();
  }, [graphApiResponse]);

  const redrawChart = () => {
    const options = {
      chart: {
        type: "bar",
      },
      title: {
        text: chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      exporting: {
        sourceWidth: 1200,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
        },
      },
      series: formatData(graphApiResponse),
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          events: {
            click: (e) => handlePointsClick(e),
          },
        },
      },
      xAxis: {
        categories: graphApiResponse.labels,
        labels: {
          style: {
            fontSize: "8px",
            textOverflow: "none",
          },
        },
      },
      yAxis: {
        title: {
          text: null,
        },
      },
    };
    setLineChartData(options);
    if (setGraphRefList) {
      setGraphRefList(reportType + mediaType, ref);
    }
  };

  const handlePointsClick = (e) => {
    try {
      const {
        point: {
          category,
          series: { name },
        },
      } = e;
      const [label, legend] = [category, name];
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOARanking ||
        reportType === JournalistNOATrend ||
        reportType === JournalistAnalysisPrint ||
        reportType === PublicationNOARanking ||
        reportType === PublicationNOATrend ||
        reportType === MediaWiseNOARanking ||
        reportType === ThematicAnalysisTag ||
        reportType === CityWiseNOATrend
      ) {
        clickedEntity = legend;
      }
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOATrend ||
        reportType === JournalistAnalysisPrint ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend ||
        reportType === EditionWiseNOATrend ||
        reportType == REPORT_TYPES.SOV
      ) {
        routeParams.date = label.replaceAll("-", "/");
      }
      if (reportType === JournalistNOARanking) {
        routeParams.sourceName = label;
        if (isEmbededWidget) {
          let labelArray = label.split("[");
          routeParams.sourceName = labelArray
            .slice(0, labelArray.length - 1)
            .join("[");
        }
      }
      if (reportType === JournalistAnalysisPrint) {
        routeParams.sourceName = clickedEntity;
      }
      if (reportType === PublicationNOARanking) {
        const clickedPublication = dataByReportType.filter(
          (elm) => elm.publication_name == label
        )[0];
        routeParams.publication = clickedPublication;
      }
      if (reportType === ThematicAnalysisTag) {
        const clickedCategory = dataByReportType.filter(
          (elm) => elm.category_name == label
        )[0];
        routeParams.categoryId = clickedCategory.category_id;
      }
      if (reportType === ThematicAnalysisEntity) {
        const entityClicked = dataByReportType.filter(
          (elm) => elm.entity_name == label
        )[0];

        if (entityClicked && entityClicked.data && entityClicked.data.length) {
          const clickedCategory = entityClicked.data.filter(
            (elm) => elm.category_name == legend
          )[0];
          routeParams.categoryId = clickedCategory.category_id;
        }
      }
      if (
        reportType === CityWiseNOARanking ||
        reportType === EditionWiseNOATrend ||
        reportType === CityWiseCCMRanking
      ) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == legend
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (reportType === MediaWiseNOARanking) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == label
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (
        reportType === JournalistTonalityNOARanking ||
        reportType === TonalityNAORanking ||
        reportType === PublicationTonalityNOARanking ||
        reportType === CityWiseTonality ||
        reportType === StateWiseTonality ||
        reportType === CityWiseCCMTonality ||
        reportType === CityWiseMAVTonality
      ) {
        const tone = legend;
        routeParams.tonality = tone;
      }

      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      onEntityClick({}, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className={isEmbededWidget ? "biggerWidget" : ""}>
      <HighchartsReact
        highcharts={Highcharts}
        options={lineChartData}
        ref={ref}
      />
    </div>
  );
};

HorizontalBarChartHC.defaultProps = {
  graphApiResponse: {},
  onEntityClick: () => {},
  reportType: "",
  entityList: [],
  dataByReportType: {},
  editionList: [],
  isEmbededWidget: false,
  chartTitle: "",
  setGraphRef: () => {},
  setGraphRefList: () => {},
};
